import { useState, useEffect } from '@wordpress/element';
import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import CircularProgress from '@mui/material/CircularProgress';

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Stack from '@mui/material/Stack';

// Your interactive React component
const Summaries = ({ restBaseUrl }) => {


    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [summaries, setSummaries] = useState(null);
    const [brands, setBrands] = useState(null);
    const [fields, setFields] = useState(null);
    const [searchParams, setSearchParams] = useState(new URLSearchParams(window.location.hash.replace('#', '')));

    useEffect(() => {
       
        const fetchBrands = async () => {
            try {
                const response = await fetch( `${restBaseUrl}wp/v2/brand?per_page=100`  )
                const result = await response.json();

                setBrands(result.filter((brand) => brand.parent !=0)); 
            } catch (err) {
                setError(err);
            } 
        }

        const fetchFields = async () => {
            try {
                const response = await fetch( `${restBaseUrl}foodservices/nutrition_facts_fields`  )
                const result = await response.json();
                setFields(result.filter((field) => field.summary )); 
            } catch (err) {
                setError(err);
            } 
        }

        const fetchData = async () => {
            setLoading(true);
            setSummaries(null);
            const params = new URLSearchParams(window.location.hash.replace('#', ''));
            setSearchParams(params);
            try {
                const response = await fetch( `${restBaseUrl}foodservices/nutritional_summaries?${params.toString()}` )
                const result = await response.json();
                setSummaries(result); 
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }     
        }
        fetchBrands().then(fetchFields).then(fetchData).then(() =>{
            window.addEventListener('hashchange', fetchData);
        });
       
        
        return () => {
          window.removeEventListener('hashchange', fetchData);
        };
    }, []);
    
    if (error) {
        return <div>Error: {error.message}</div>;

    }

    const handlePageChange = (event, value) => {
        //console.log(value,  summaries.pageSize);
        //const params = new URLSearchParams(window.location.hash.replace('#', ''));
        searchParams.set('offset', (value-1) * summaries.pageSize);
        location.hash = searchParams.toString();

    };

    const handleBrandChange = (event) => {
        if (event.target.value) {
            searchParams.set('brand',event.target.value);
        } else {
            searchParams.delete('brand');
        }
        searchParams.delete('offset');
        location.hash = searchParams.toString();
    };

    return (
        <div>
            {brands && 
            <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                    <InputLabel id="brand-label">Brand</InputLabel>
                    <Select
                      labelId="brand-label"
                      id="brand-select"
                      value={searchParams.get('brand')}
                      label="Brand"
                      onChange={handleBrandChange}
                    >
                        <MenuItem value=''>All Brands</MenuItem>
                    {brands.map((brand) =>
                        <MenuItem value={brand.id}><span dangerouslySetInnerHTML={{ __html:brand.name}} /></MenuItem>
                    )}    
                    </Select>
                </FormControl>
            </Box>
            }
            {loading && <Box sx={{ display: 'flex' }}>
              <CircularProgress />
            </Box>}
            {summaries && <>
                {summaries?.brandList.map((brand) => 
                    <Stack className="brand_group" direction="row" spacing={0} style={{ width:"100%", overflow: 'hidden'}}>
                        <div style={{ flex: 'initial'}}>
                        <Table className="labels"  size="small" sx={{ width: '250px' }}>
                            <TableHead >
                                <TableRow sx={{ height: '5em' }}>
                                    <TableCell>
                                        <a href={brand.brand_url}>
                                            {brand.brand_logo && <img style={{height: '4em'}} src={brand.brand_logo} alt={brand.brand_name} title={brand.brand_name}/>}
                                            {!brand.brand_logo && <span dangerouslySetInnerHTML={{ __html: brand.brand_name}} />}
                                        </a>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {brand.products.map((product) => 
                                <TableRow sx={{ height: '3em' }}>
                                    <TableCell>
                                        <a href={product.url} 
                                            dangerouslySetInnerHTML={{ __html:product.title}}>      
                                        </a>
                                    </TableCell>
                                </TableRow>
                            )}
                            </TableBody>
                        </Table>
                        </div>
                        <div style={{ flex: 'auto', overflow: 'auto'}}>
                        <Table className="fields"  size="small">
                            <TableHead>
                                <TableRow sx={{ height: '5em' }}>
                                    {fields.map((field) => 
                                        <TableCell><span class="label">{field.abbrev ? field.abbrev : field.label}</span>
                                            {field.unit && <span class="unit">({field.unit})</span>}
                                        </TableCell>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {brand.products.map((product) => 
                                <TableRow sx={{ height: '3em' }}>
                                    {fields.map((field) => 
                                        <TableCell>{product[field.name]}</TableCell>
                                    )}
                                </TableRow>
                            )}
                            </TableBody>
                        </Table>
                    </div>
                    </Stack>
                )}
                {summaries.totalCount > summaries.pageSize && <Pagination 
                    count={Math.ceil(summaries.totalCount / summaries.pageSize)} 
                    page={(searchParams.get('offset') / summaries.pageSize) + 1}
                    onChange={handlePageChange} 
                />}
            </>}
            
        </div>
    );
};

export default Summaries;